const AIR_TECHNIQUES_REFS = [
  'G8300',
  'G8300A',
  'G8000',
  'G8010',
  'G8800',
  'G8800A',
  'G8500',
  'G8500A',
  'G8900',
  'G8900A',
  'G8600',
  'G8600A',
  'G8700',
  'G8700A',
  'J1200',
  'J1205',
  'J1200J',
  'J1205E',
  'J1205J',
  'D1000',
  'D1000F',
  'D1100',
  'F3600',
  'F3605',
  'F3700',
  'F3705',
  'F3750',
  'AS10',
  'AS10NEO',
  'AS12',
  'AS21',
  'AS21NEO',
  'AS22',
  'AS22NEO',
  'AS30',
  'AS30NEO',
  'AS40',
  'AS40NEO',
  'AS50',
  'AS50NEO',
  'AS70',
  'AS70NEO',
  'MMC-M',
  'MMC-KT',
  'LT3',
  'LT5',
  'LT3M',
  'LT5M'
]

export { AIR_TECHNIQUES_REFS }
